<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>财务系统</el-breadcrumb-item>
            <el-breadcrumb-item>转款记录</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row style="text-align:left;margin-bottom:10px">
        <el-col :span="24">
          <el-form :model="searchForm" :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-date-picker v-model="searchForm.rangeDate" type="daterange" range-separator="至" unlink-panels
                start-placeholder="开始日期" end-placeholder="结束日期" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" :picker-options="pickerOptions" style="width: 250px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-input size="small" clearable v-model="searchForm.searchName" placeholder="请输入公司名称或账户名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" icon="el-icon-search" @click="SearchByName">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="Renewals" show-summary style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="OrderNo" label="订单编号"></el-table-column>
            <el-table-column prop="CreateTime" label="创建时间"></el-table-column>
            <el-table-column prop="OrderName" label="订单名称"></el-table-column>
            <el-table-column prop="UserName" label="用户名称"></el-table-column>
            <el-table-column prop="TotalMoney" label="支付金额"></el-table-column>
            <el-table-column prop="Coupon" label="优惠"></el-table-column>
            <el-table-column prop="PayType" :formatter="payType" label="支付方式"></el-table-column>
            <el-table-column prop="PayStatus" :formatter="payStatus" label="支付状态"></el-table-column>
            <el-table-column prop="PayTime" label="支付时间"></el-table-column>
            <el-table-column prop="TransferStatus" :formatter="TransferStatus" label="转款状态"></el-table-column>
            <el-table-column prop="TransferTime" label="转账时间"></el-table-column>
            <el-table-column prop="IsTicket" :formatter="isTicket" label="开具发票"></el-table-column>
            <el-table-column prop="result" :formatter="result" label="发票类型"></el-table-column>
            <el-table-column prop="msg" label="发票信息"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row style="margin-top:10px">
        <el-col :span="24">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
            :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount" style="float:right"></el-pagination>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { GetOrderPageList } from "../../until/ZeusApiSDK/Logic/FinancialLogic";
import {
  GetCurrentUserInfo,
  GetCurrentUserRole
} from "../../until/ZeusApiSDK/Logic/HomeLogic";
export default {
  data() {
    return {
      searchForm: {
        searchName: "",
        rangeDate: ""
      },
      Renewals: [],
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading: true,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 182);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  },
  created() {
    this.GetRenewalPageList();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetRenewalPageList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetRenewalPageList();
    },
    SearchByName: function () {
      this.pageIndex = 1;
      this.GetRenewalPageList();
    },
    //刷新
    Refresh: function () {
      this.GetRenewalPageList();
    },
    GetRenewalPageList: async function () {
      this.loading = true;
      var userinfo = GetCurrentUserInfo();
      var currentUserRole = await GetCurrentUserRole();
      var isAll = "0";
      if (currentUserRole.Key == "admin") {
        isAll = "all";
      }
      if (this.searchForm.rangeDate == "" || this.searchForm.rangeDate == null) {
        var date = new Date();
        var s1 = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + (date.getDate());
        this.searchForm.rangeDate = [s1, s1]
      }
      GetOrderPageList(
        userinfo.UserCode,
        isAll,
        this.pageIndex,
        this.pageSize,
        this.searchForm.rangeDate[0],
        this.searchForm.rangeDate[1],
        this.searchForm.searchName
      ).then(pageRes => {
        this.Renewals = pageRes.DataList;
        this.totalCount = pageRes.TotalCount;
        this.loading = false;
      });
    },
    payType(row, column, cellValue, index) {
      if (cellValue == 0) {
        return "支付宝支付";
      } else if (cellValue == 1) {
        return "微信支付";
      } else if (cellValue == 2) {
        return "中信微信";
      } else if (cellValue == 3) {
        return "中信支付宝";
      } else if (cellValue == 4) {
        return "民生私对公";
      } else if (cellValue == 5) {
        return "代付款";
      } else if (cellValue == 6) {
        return "公对公转账";
      } else if (cellValue == 7) {
        return "民生公对公";
      } else if (cellValue == 8) {
        return "新开户";
      } else if (cellValue == 9) {
        return "手动转账";
      } else if (cellValue == 12) {
        return "光大微信";
      } else if (cellValue == 13) {
        return "光大支付宝";
      }
    },
    payStatus(row, column, cellValue, index) {
      if (cellValue == 0) {
        return "未支付";
      } else if (cellValue == 1) {
        return "已支付";
      }
    },
    result(row, column, cellValue, index) {
      if (cellValue == 0) {
        return "普票";
      } else if (cellValue == 1) {
        return "专票";
      }
    },
    isTicket(row, column, cellValue, index) {
      if (cellValue == 0) {
        return "未开具";
      } else if (cellValue == 1) {
        return "已开具";
      }
    },
    //判断转账状态
    TransferStatus(row, column, cellValue, index) {
      if (cellValue == 0 || cellValue == -1) {
        return "未转账";
      } else if (cellValue == 1) {
        return "已转账";
      } else if (cellValue == 2) {
        return "不转账";
      }
    }
  }
};
</script>